import React from 'react';

/* eslint import/no-extraneous-dependencies: 0 */
// node-build has this set as a dev-dep
import { PropTypes as T } from 'prop-types';

import './styles.scss';

export default function Button({ children }) {
  return (
    <button>{children}</button>
  );
}

Button.propTypes = {
  children: T.node,
};
